import * as React from "react";
import debounce from "debounce";
import "tabbable";
class Truncate extends React.Component {
  constructor(props) {
    super(props);
    this.element = null;
    this.innerElement = null;
    this.updateIsShown = () => {
      if (this.state.truncate !== this.showTruncateFade()) {
        this.setState({
          truncate: this.showTruncateFade()
        });
      }
    };
    this.state = {
      truncate: this.showTruncateFade()
    };
    this.debouncedResizeHandler = debounce(this.updateIsShown, 50);
  }
  componentDidMount() {
    if (this.props.variant) {
      window.addEventListener("resize", this.debouncedResizeHandler);
      this.updateIsShown();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.updateIsShown();
    }
  }
  componentWillUnmount() {
    if (this.props.variant) {
      window.removeEventListener("resize", this.debouncedResizeHandler);
    }
    this.debouncedResizeHandler.clear();
  }
  showTruncateFade() {
    return this.element && this.innerElement ? Math.floor(this.element.offsetWidth) < Math.floor(this.innerElement.offsetWidth) : true;
  }
  BEM() {
    const classArray = ["truncate"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    if (this.props.variant) {
      classArray.push("truncate--".concat(this.props.variant));
    }
    if (this.state.truncate && this.props.variant === "fade") {
      classArray.push("truncate--shown");
    }
    return classArray.join(" ");
  }
  render() {
    return /* @__PURE__ */ React.createElement("span", { className: this.BEM(), ref: (el) => this.element = el }, /* @__PURE__ */ React.createElement("span", { className: "truncate__inner", ref: (el) => this.innerElement = el }, this.props.children));
  }
}
export {
  Truncate
};
